export function asAddress(address?: string): `0x${string}` {
  if (!address || !/^0x[a-fA-F0-9]{40}$/.test(address)) {
    throw new Error(`Invalid address format: ${address || 'Empty string'}`);
  }
  return address as `0x${string}`;
}
